export const DIMBO_CONSTANT = {
  // API endpoints
  API_ENDPOINT: "",

  // Configs
  I18N_ENDPOINT: "/assets/i18n",
  CONFIG_ENDPOINT: "/assets/config/config.json",
  API_ENDPOINT_KEY: "apiUrl",
  TOKEN_VALIDATE_INTERVAL_KEY: "tokenInterval",
  PAGE_COUNT_KEY: "pageCount",

  // Date Format
  DATE_FROMAT: "dd-MM-yyyy",

  // i18n Default
  DEFAULT_LOCALE: "en",

  // Cache Keys
  CACHE_SERVICE_BOX_TOKEN: "service_box_token",
  CACHE_I18N_LOCALE: "i18n_locale",
  CACHE_I18N_DATA: "i18n_data",
  CACHE_USER_ID: "user_id",
  CACHE_USER_ROLE: "user_role",
  CACHE_USER_ROLES: "user_roles",
  CACHE_ACCESS_PATH: "access_path",
  CACHE_QUERY_PARAMS: "query_params",
  CACHE_IS_VALID_USER: "is_valid_user",
  CACHE_IS_VALID_ROLE: "is_valid_role",
  CACHE_JWT_TOKEN: "jwt_token",
  CACHE_JWT_VIN: "vin",

  CACHE_JWT_TOKEN_RESPONSE: "jwt_token_response",
  CACHE_JWT_SOURCE_APPLICATION: "jwt_token_source_application",
  CACHE_JWT_LANGUAGE: "jwt_token_language",
  CACHE_JWT_LANGUAGE_RAW: "jwt_token_language_raw",
  CACHE_JWT_REPAIRER_COUNTRY: "jwt_token_repairer_country",
  CACHE_JWT_CUSTOMER_LAST_NAME: "jwt_token_customer_last_name",
  CACHE_JWT_REPAIRER_NAME: "jwt_token_repairer_name",
  CACHE_JWT_REPAIRER_CITY: "jwt_token_repairer_city",
  CACHE_JWT_REPAIRER_ADDRESS: "jwt_token_repairer_address",
  CACHE_JWT_REPAIRER_ZIP: "jwt_token_repairer_zip",
  CACHE_JWT_MILEAGE: "jwt_token_mileage",
  CACHE_JWT_MILEAGE_UNIT: "jwt_token_mileage_unit",
  CACHE_JWT_VIN_BRAND: "jwt_token_vin_brand",
  CACHE_JWT_VEHICLE_TYPE: "jwt_token_vehicle_type",

  CACHE_JWT_USER_ID: "jwt_token_user_id",
  CACHE_JWT_POS: "jwt_token_pos",
  CACHE_JWT_RRDI: "jwt_token_rrdi",
  CACHE_JWT_COMPANY_NAME: "jwt_token_company_name",
  CACHE_JWT_ISS: "jwt_token_iss",
  CACHE_JWT_REPAIRER_BRAND: "jwt_token_repairer_brand",
  CACHE_JWT_EXPIRATION: "jwt_token_expiration",
  CACHE_JWT_EXP: "jwt_token_exp",
  CACHE_JWT_IAT: "jwt_token_iat",
  CACHE_JWT_LOCALE: "jwt_token_locale",

  CACHE_FORM_DATA: "allurecare_form_data",
  CACHE_INITIAL_MILEAGE_PROMPT: "initial_mileage_prompt_done",
  CACHE_IS_CUSTOMER_VERIFIED: "is_customer_verified",
  CACHE_BRAND: "brand",
  CACHE_CONTRACT_ID: "contractId",
  CACHE_REGISTRATION: "registration",
  CACHE_FIRST_REGISTRATION_DATE: "first_registration_date",
  CACHE_CURRENT_MILEAGE: "currrent_mileage",
  CACHE_MILEAGE_UNIT: "mileage_unit",
  CACHE_IS_CENTRAL_USER: "is_central_user",
  CACHE_IS_ADMIN_USER: "is_admin_user",
  CACHE_IS_READ_ONLY: "is_read_only",
  CACHE_CUSTOMER_VERIFICATION_RETRY_COUNT: "customer_verification_retry_count",
  CACHE_VECHILE_MILEAGE: "vechile_mileage",
  CACHE_VECHILE_MILEAGE_UNIT: "vechile_mileage_unit",
  CACHE_SHE_COMMENT: "service_history_edit_commnet",
  CACHE_SHE_AP_COMMENT: "service_history_edit_ap_commnet",
  CACHE_SHE_AP_CHECK: "service_history_edit_ap_check",
  CACHE_SHE_AP_PERIOD: "service_history_edit_ap_period",
  CACHE_SHE_AP_ID: "service_history_edit_ap_id",
  CACHE_LANGUAGE_LOCAL: "locale",
  CACHE_CREATE_SERVICE_SCOPE: "create_service_scope",
  CACHE_IS_MP_CALL_FIRST_TIME: "is_mp_call_first_time",
  CACHE_IS_MP_SEVERE_HAS_DATA: "is_mp_severe_has_data",
  CACHE_SH_SCROLL_COUNT: "sh_scroll_count",
  CACHE_IS_SH_TAB: "is_sh_tab",
  CACHE_CREATE_CURRENT_USAGE: "selected_usage",
  CACHE_CIN_BRAND: "cin_brand",
  CACHE_MILEAGE_UNIT_MATCH: "doesMileageUnitMatch",
  CACHE_MILEAGE_UNIT_MATCH_VAL: "frequencyMileageUnit",
  CACHE_IS_OV_LEGACY: "isOvLegacy",
  CACHE_SUBMISSION_MODE: "submission_mode", // New Submission History Change

  FCA_BRANDS: ["CY", "DG", "JE", "RM", "AR", "FT", "LA", "AH", "FO"],

  // API url
  AUTHENTICATE_TOKEN: "/authAllucare",
  BRANDCARE_FORM: "/brandcareform/form",
  BRANDCARE_SUBMISSION_HISTORY: "/brandcareform/{vin}/submission-history",
  BRANDCARE_SUBMISSION_HISTORY_FILTER: "/brandcareform/filter/submission-history", // CAP-39922 DMBR-64
  BRANDCARE_SUBMISSION: "/brandcareform/form-submission",

  VALIDATE_TOKEN: "/validate/jwt-token",
  SERVICE_HISTORY_EP: "",
  MAINTENANCE_PLAN: "/maintenance-plans/UI",
  CUSTOMER_VERIFY: "/customer-challenge",
  EDIT_VEHICLE_INFO_CHECK: "edit_vehicle_info_check",
  FCA_VEHICLE_INFORMATION: "/exfca/{vin}/vehicle-information",
  CACHE_BRAND_READ_ONLY: "brand_read_only",
  CACHE_VIN_READ_ONLY: "vin_read_only",
  ABACUS_DETAILS: "/abacusDetails",
  LAST_LOGIN_TIME: "/user-login-history", // Added this line for last login timestamp API

  // New cache keys for Panier flow
  CACHE_JWT_MODEL: "jwt_token_model",
  CACHE_JWT_VIN_RRDI: "jwt_vin_rrdi",
  CACHE_JWT_RECEPTION_RRDI: "jwt_reception_rrdi",
  CACHE_JWT_BRAND: "jwt_brand",
  CACHE_JWT_FIRST_REGISTRATION_DATE: "jwt_token_first_registration_date",
  CACHE_JWT_WARRANTY_START_DATE: "jwt_token_warranty_start_date",
  CACHE_JWT_ENGINE_TYPE: "jwt_token_engine_type",
  CACHE_JWT_EMAIL: "jwt_token_email",
  CACHE_JWT_WORK_LINES: "jwt_token_work_lines",
  CACHE_JWT_AFTER_SALES_LABOUR_RATES: "jwt_token_after_sales_labour_rates",
  CACHE_JWT_FOLDER_PNR_ID: "jwt_token_folder_pnr_id",
  CACHE_JWT_FOLDER_DMS_ID: "jwt_token_folder_dms_id",
  CACHE_JWT_CONTRACT_ID: "jwt_token_contract_id",
  CACHE_JWT_CONTRACT_LABEL: "jwt_token_contract_label",
  CACHE_JWT_CEM_TYPE: "jwt_token_cem_type",
  CACHE_JWT_CONTRIBUTION_FLAG: "jwt_token_contribution_flag",
  CACHE_BRANDCARE_TITLE: "brandcare_title",
  CACHE_JWT_PHSYSICAL_SITE: "jwt_token_physical_site",

  CACHE_ACCESS_TOKEN: "access_token",
  CACHE_REFRESH_TOKEN: "refresh_token",
  CACHE_LAST_LOGIN_DATE_TIME: "lastLoginDateTime",

  BRAND_CARE_TITLE: "8 year Warranty program",
};
